import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DocumentationTranport } from "src/app/transports/documentation";
import { Documentation, defaultDocumentation } from "src/app/types/documentation";
const useDocumentation = () => {
    const [oldDocumentation, setOldDocumentation] = useState<Documentation>(defaultDocumentation);

    const [documentation, setDocumentation] = useState<Documentation>(defaultDocumentation);

    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const changeHtml = (newHtml: string) => {
        const auxDocumentation = { ...documentation, html: newHtml };
        setDocumentation(auxDocumentation);
    };

    const fetch = () => {
        setLoading(true);
        DocumentationTranport.getDocument({ pathname: location.pathname })
            .then((res) => {
                setOldDocumentation(res);
                setDocumentation(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const saveDocumentation = () => {
        setLoading(true);
        documentation.pathname = location.pathname;
        DocumentationTranport.save(documentation)
            .then((res) => {
                if (res) {
                    setOldDocumentation(res);
                    setDocumentation(res);
                }
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const goBack = () => {
        setDocumentation(oldDocumentation);
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        fetch();
    }, [location.pathname]);

    return { documentation, changeHtml, goBack, saveDocumentation, refresh, error, loading };
};

export default useDocumentation;
